import { QuestionIds } from 'onboarding/data/constants/QuestionIds';

export const LivenQuestionsOrder: QuestionIds[] = [
  QuestionIds.WellbeingQ1,
  QuestionIds.WellbeingQ2,
  QuestionIds.WellbeingQ3,
  QuestionIds.WellbeingQ4,
  QuestionIds.WellbeingQ5,
  QuestionIds.WellbeingQ6,
  QuestionIds.WellbeingQ7,
  QuestionIds.WellbeingQ8,
  QuestionIds.WellbeingQ9,
  QuestionIds.WellbeingQ10,
  QuestionIds.WellbeingQ11,
  QuestionIds.WellbeingQ12,
  QuestionIds.WellbeingQ13,
  QuestionIds.WellbeingQ14,
  QuestionIds.WellbeingQ15,
  QuestionIds.WellbeingQ16,
  QuestionIds.WellbeingQ17,
  QuestionIds.WellbeingQ18,
  QuestionIds.WellbeingQ19,
  QuestionIds.WellbeingQ20,
  QuestionIds.WellbeingQ21,
  QuestionIds.WellbeingQ22,
  QuestionIds.WellbeingQ23,
  QuestionIds.WellbeingQ24,
  QuestionIds.WellbeingQ25,
  QuestionIds.WellbeingQ26,
  QuestionIds.WellbeingQ27,
  QuestionIds.WellbeingQ28,
  QuestionIds.WellbeingQ29,
  QuestionIds.WellbeingQ30,
  QuestionIds.WellbeingQ31,
  QuestionIds.WellbeingQ32,
  QuestionIds.WellbeingQ33,
  QuestionIds.WellbeingQ34,
  QuestionIds.WellbeingQ35,
];
